<app-card-container>
    <div class="__container u-container">
        <app-confirmations-short-period-chart></app-confirmations-short-period-chart>
        <app-confirmations-long-period-chart></app-confirmations-long-period-chart>
        <app-confirmations-cluster-levels-chart></app-confirmations-cluster-levels-chart>
    </div>
</app-card-container>
